export default __webpack_public_path__ + "static/clipboard-activity-light-7db546303991c805d7bb3bcc5c481fc3.png";